import React from "react";
import ClientCrudTableRow from "./ClientCrudTableRow";
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";
import ReactPaginate from "react-paginate";
import { ITEMS_BY_PAGE_OPTIONS } from "constants/pagination";

const ClientCrudTable = ({
    clients,
    editData,
    deleteData,
    listClients,
    handleShow,
    listLines,
    listLinesByDocumentClient,
    vinculedLine,
    setnumDocumentFromModal,
    amountPages,
    setSelectedClient,
    getVinculedDirections,
    setModalVincularDireccion,
    getVinculedEmails,
    setModalVincularCorreo,
    itemsPerPage,
    setItemsPerPage,
    resetSearch,
    hasSearched,
}) => {
    let myAbilities = HelpAbility();
    const handlePageClick = async (data) => {
        listClients(data.selected + 1);
    };

    const resetList = async () => {
        listClients(1);
        resetSearch();
    };

    const onItemsPerPageChange = (e) => {
        const newItemsPerPage = e.target.value;
        setItemsPerPage(newItemsPerPage);
        listClients(1, newItemsPerPage)
    }

    return (
        <div className="mt-4">
            <div className="row mb-2">
                <div className="col d-flex align-items-end">
                    <h6>Clientes registratos</h6>
                </div>
                <div className="col d-flex justify-content-end"> 
                    <div className="d-flex flex-row gap-3">
                    <div className="col d-flex flex-row align-items-center gap-2">
                        <label htmlFor="items-by-page" className="form-label mb-0">Mostrar: </label>
                        <select onChange={onItemsPerPageChange} disabled={hasSearched} className="form-select form-select-sm" aria-label="Default select example" name="items-by-page" style={{width: '70px'}} value={itemsPerPage}>
                        {
                            ITEMS_BY_PAGE_OPTIONS.map((value) => (
                                <option value={value} key={'item-by-page-option-' + value}>{value}</option>                
                            ))
                        }            
                        </select>
                    </div>
                    <button type="submit" className="btn btn-primary" onClick={resetList} disabled={!hasSearched}>Limpiar búsqueda</button>
                    </div>
                </div>
            </div>
            <div className="table-responsive rounded-3" style={{border: '1px solid black'}}>
                <table className="table">
                    <thead>
                    <tr>
                        {/*{code, name, numDocument, documentType, mail, hasActiveReserve, hasMora, maximumFinancingAmount, _id} = el; */}
                        <th scope="col">#</th>
                        <th scope="col" className="text-center">Nombre</th>
                        <th scope="col" className="text-center">Apellidos</th>
                        <th scope="col" className="text-center">Número de Documento</th>
                        <th scope="col" className="text-center">Tipo de Documento</th>
                        <th scope="col" className="text-center">Correo</th>
                        <th scope="col" className="text-center">Tiene Reserva Activa</th>
                        <th scope="col" className="text-center">Tiene Mora</th>
                        <th scope="col" className="text-center">Entidad Consultada</th>
                        <th scope="col" className="text-center">Monto max. de Financiamiento</th>
                        <th scope="col" className="text-center">Tipo de Cliente</th>
                        <th scope="col" className="text-center">Número de Lineas</th>
                        <th scope="col" className="text-center">Número de Direcciones</th>
                        <th scope="col" className="text-center">Número de Correos</th>


                        {myAbilities.hasAny([C.A.CUSTOMER.UPDATE, C.A.CUSTOMER.LINK, C.A.CUSTOMER.DELETE]) &&
                        <th scope="col" className="text-center">Acción</th>}
                    </tr>
                    </thead>
                    <tbody>
                    {
                        clients.length > 0 ? clients.map((el, i) => <ClientCrudTableRow key={el._id}
                                                                                        el={el}
                                                                                        i={i}
                                                                                        editData={editData}
                                                                                        deleteData={deleteData}
                                                                                        handleShow={handleShow}
                                                                                        listLines={listLines}
                                                                                        listLinesByDocumentClient={listLinesByDocumentClient}
                                                                                        vinculedLine={vinculedLine}
                                                                                        setnumDocumentFromModal={setnumDocumentFromModal}
                                                                                        setSelectedClient={setSelectedClient}
                                                                                        getVinculedDirections={getVinculedDirections}
                                                                                        setModalVincularDireccion={setModalVincularDireccion}
                                                                                        getVinculedEmails={getVinculedEmails}
                                                                                        setModalVincularCorreo={setModalVincularCorreo}

                            />) :
                            <tr>
                                <td colSpan="5">Sin datos</td>
                            </tr>
                    }
                    </tbody>
                </table>
            </div>
            <div>
                {
                    !hasSearched ? 
                    <ReactPaginate
                        previousLabel={"Anterior"}
                        nextLabel={"Siguiente"}
                        breakLabel={"..."}
                        pageCount={amountPages}
                        //Cuantas paginas quieres mostrar despues d elos 3 ...
                        marginPagesDisplayed={1}
                        //En cada pagina tiene dos lados, uno izquierda y otro derecha, cuantas n paginas quieres en eso dos lados, excepto para la primera y ultima pagina que para estos cubriran n paginas pero para su dirección de ida o retorno de lado respectivamente
                        pageRangeDisplayed={2}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination justify-content-center mt-3"}
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        previousClassName={"page-item"}
                        previousLinkClassName={"page-link"}
                        nextClassName={"page-item"}
                        nextLinkClassName={"page-link"}
                        breakClassName={"page-item"}
                        breakLinkClassName={"page-link"}
                        activeClassName={"active"}
                    />
                    : null
                }
            </div>
        </div>
    );
}
export default ClientCrudTable;
